<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="outer-wrapper py-10 md:py-20 px-4 flex flex-col items-center">
    <div class="max-w-wrapper-lg mx-auto">
      <div
        v-if="title || $slots.title"
        class="mx-auto text-center text-2xl/[120%] md:text-4xl/[120%] mb-2 md:mb-4 text-semantic-inverse-surface font-semibold"
      >
        <slot name="title">
          <p ref="title" v-html="title" />
        </slot>
      </div>
      <div
        v-if="subTitle || $slots.subTitle"
        class="mx-auto md:text-lg/[150%] text-center text-semantic-inverse-surface"
      >
        <slot name="subTitle">
          <p v-html="subTitle" />
        </slot>
      </div>
      <div
        class="item-container w-full grid grid-cols-1 gap-4 md:gap-8"
        :class="[
          itemsPerRow ? `md:grid-cols-${itemsPerRow}` : 'md:grid-cols-3',
          title || subTitle || $slots.title || $slots.subTitle
            ? 'md:mt-10 mt-6'
            : 'mt-0',
        ]"
      >
        <V2AtomsBaseCard
          v-for="(item, index) in items"
          :key="index"
          size="small"
          class="!max-w-full"
        >
          <Component
            :is="item.icon"
            v-if="item.icon"
            :fill="semanticColorLookup('primary.default')"
            v-bind="item.iconProps"
            class="icon mb-2.5 flex-shrink-0 self-center"
          />
          <V2IconsCheckCircle
            v-else
            class="icon flex-shrink-0 self-center mb-2.5"
            :fill="semanticColorLookup('primary.default')"
          />
          <div
            class="text-base/[150%] text-semantic-surface-on-surface md:text-lg/[150%] flex flex-col md:gap-4 gap-2"
          >
            <!-- eslint-disable vue/no-v-html -->
            <p
              v-if="item.title"
              class="font-semibold md:text-2xl/[120%] text-lg/[120%]"
              v-html="item.title"
            />
            <p v-if="item.description" v-html="item.description" />
          </div>
        </V2AtomsBaseCard>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesHomeIconContent'
})

defineProps({
  title: {
    type: String,
    default: ''
  },

  subTitle: {
    type: String,
    default: ''
  },

  items: {
    type: Array,
    required: true
  },

  itemsPerRow: {
    type: Number,
    default: 3
  }
})
</script>
